<template>
  <sliderBarDialogShell
    :dialog-show="dialogShow"
    :dialog-title="title"
    @close="close"
    @submit="confirm"
    class="addlinks-dialog"
  >
    <feishu-form
      ref="form"
      @submit="submitHandle"
    ></feishu-form>
  </sliderBarDialogShell>
</template>

<script>
import { saveFeishuConfig } from '@/api/sys/robitConfig/feishu'
import feishuForm from '@/components/sys/robitCofig/feishu/feishuForm'

export default {
  name: 'addfeishu',
  components:{
    feishuForm,
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      title: '新增飞书推送渠道'
    }
  },
  methods: {
    close(){
      this.$refs.form.$refs.form.clearValidate();
      this.$emit('close');
    },

    cancel(){
      this.close();
    },
    confirm() {
      this.$refs.form.validate();
    },
    submitHandle(formData){
      let params = {
          name: formData.robitName,
          desc: formData.desc,
          hookUrl: formData.hookUrl,
          status: formData.status,
      }
      saveFeishuConfig(params).then((res) => {
        this.$refs.form.$refs.form.clearValidate();
        this.$refs.form.$refs.form.resetFields();

        this.$emit('add-success');
        this.$refs.form.reset();
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.addlinks-dialog {
  .el-select {
    width: 100%;
  }
}
</style>
